import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-log-phone-dialog',
  templateUrl: './log-phone-dialog.component.html',
  standalone: false,
})
export class LogPhoneDialogComponent {
  leadId: string;

  call: any = {};

  constructor(
    public dialogRef: MatDialogRef<LogPhoneDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      leadId: string;
    },
  ) {
    this.leadId = data.leadId;
  }

  ngOnInit() {
    this.call.date = new Date().toLocaleDateString();
    this.call.time = new Date().toLocaleTimeString();
  }

  ngAfterViewInit() {}

  btnSubmit_click() {
    this.dialogRef.close(true);
  }

  btnClose_click() {
    this.dialogRef.close(false);
  }
}
